export default __webpack_public_path__ + "static/media/Activity13.188b162b.jpeg";